import React from 'react';
import {Grid, Box, Typography, Button, TextField, InputLabel, Select, MenuItem, Modal, Fade, Backdrop} from '@material-ui/core';
import MainContentWrapper from '../../components/wrappers/MainContent/MainContent';
import BlockWrapper from '../../components/wrappers/Block/Block';
import Heading from '../../components/heading/Heading';
import {serviceTypeFilter, languagesOptions } from "../../components/blocks/filter/filterOptions";
import './Invite.sass'

export const InviteJSX = ({
  handleInviteSubmission,
  handleSelectChange,
  handleSelectOptions,
  selectValue,
  selectedOptions,
  emailValue,
  handleEmailChange,
  emailInvalid,
  successModalOpen,
  handleModalClose,
  handleLanguageOptions,
  languageOptions,
  languageInvalid,
  serviceTypeInvalid
}) => {
    return (
        <MainContentWrapper>
            <Box mt={3.157} mb={1}>
                <Heading>Invite a Patient</Heading>
            </Box>
            <BlockWrapper>
                <form onSubmit={handleInviteSubmission}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Box mx={1}>
                                <InputLabel className='form-label primary-font'>Status <span style={{ color: 'black' }}>*</span></InputLabel>
                                <Select
                                    name='status'
                                    className={'status-select'}
                                    onChange={handleSelectChange}
                                    value={selectValue}
                                    fullWidth
                                >
                                    <MenuItem value={'accepted'}>Accepted</MenuItem>
                                    <MenuItem value={'declined'}>Declined</MenuItem>
                                </Select>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Box mx={1}>
                                <InputLabel className='form-label primary-font'>Language <span style={{ color: 'black' }}>*</span></InputLabel>
                                <Select
                                    name="language"
                                    className={'status-select'}
                                    onChange={handleLanguageOptions}
                                    value={languageOptions}
                                    error={languageInvalid}
                                    fullWidth
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                            },
                                        },
                                    }}
                                >
                                    {languagesOptions.map((option, index) => (
                                        <MenuItem key={index} value={option.value}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {languageInvalid && <Typography variant={'subtitle1'} className={'error-text'}>Please select a language</Typography>}
                            </Box>
                        </Grid>

                        {selectValue === 'accepted' &&
                            <Grid item xs={12}>
                                <Box mx={1} mt={2}>
                                    <InputLabel className='form-label primary-font'>Email Address <span style={{ color: 'black' }}>*</span></InputLabel>
                                    <TextField
                                        value={emailValue}
                                        onChange={handleEmailChange}
                                        variant={'outlined'}
                                        size={'small'}
                                        className='full-width input-theme'
                                        fullWidth
                                        error={emailInvalid}
                                    />
                                    {emailInvalid && <Typography variant={'subtitle1'} className={'error-text'}>Please enter a valid email address</Typography>}
                                </Box>
                            </Grid>
                        }

                        <Grid item xs={12}>
                            <Box mx={1} mt={2}>
                                <InputLabel className='form-label primary-font'>Service area <span style={{ color: 'black' }}>*</span></InputLabel>
                                <Select
                                    name='service_type'
                                    className={'status-select'}
                                    onChange={handleSelectOptions}
                                    value={selectedOptions}
                                    error={serviceTypeInvalid}
                                    fullWidth
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                            },
                                        },
                                    }}
                                >
                                    {serviceTypeFilter.map((option, index) => (
                                        <MenuItem key={index} value={option.value}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {serviceTypeInvalid && <Typography variant={'subtitle1'} className={'error-text'}>Please select a service area</Typography>}
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Box mx={1} my={3.157}>
                                <Button variant="contained" align="center" className='btn-theme' type='submit'><strong>Submit</strong></Button>
                            </Box>
                        </Grid>
                    </Grid>
                </form>
            </BlockWrapper>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={'modal'}
                open={successModalOpen}
                onClose={handleModalClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 50,
                }}
            >
                <Fade in={successModalOpen}>
                    <div className={'modal-paper'}>
                        <Typography variant={'h5'} className={'success-message'}>Invite submitted successfully</Typography>
                        <Button onClick={handleModalClose} variant="contained" align="center" className='btn-theme'><strong>Close</strong></Button>
                    </div>
                </Fade>
            </Modal>
        </MainContentWrapper>
    )
}

export default InviteJSX